// Opens header dropdown menus on hover for pointer devices; click and keyboard keep working as before.
(function () {
  const hoverQuery = window.matchMedia('(hover: hover) and (min-width: 990px)');

  function bindMenu(details) {
    if (details.dataset.hoverBound) return;
    details.dataset.hoverBound = 'true';
    let closeTimer;

    details.addEventListener('mouseenter', () => {
      if (!hoverQuery.matches) return;
      clearTimeout(closeTimer);
      details.setAttribute('open', '');
      details.querySelector('summary')?.setAttribute('aria-expanded', 'true');
    });

    details.addEventListener('mouseleave', () => {
      if (!hoverQuery.matches) return;
      closeTimer = setTimeout(() => {
        details.removeAttribute('open');
        details.querySelector('summary')?.setAttribute('aria-expanded', 'false');
      }, 150);
    });
  }

  function init() {
    document.querySelectorAll('.header__inline-menu header-menu > details').forEach(bindMenu);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
